var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { pick } from 'lodash';
import AnimateHeight from 'react-animate-height';
import { classNames } from '@shapeable/utils';
import { ChevronDownIconGlyph, ChevronUpIconGlyph } from '@shapeable/icons';
import { DottedLine } from './dotted-line';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('collapsible-panel');
export var CollapsiblePanelDefaultProps = {
  colors: {
    background: 'canvas',
    text: 'strong'
  },
  divider: {
    width: 2,
    colors: {
      border: 'subtle'
    }
  },
  disclosure: {
    colors: {
      fill: 'mid'
    }
  }
};
// Impact Areas - Topics label in explorerView
// Map - Orgs and Challenges (filters)
// Stakeholders, resources tools, Insighta - filters for trends (Impact Areas)
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: ", ";\n    border-radius: 10px;\n    ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: ", ";\n    border-radius: 10px;\n    ", ";\n  "])), theme.UNIT(4), theme.APPLY_COLORS)
});
var HeadStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    color: inherit;\n    align-self: stretch;\n    font-weight: 500;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    color: inherit;\n    align-self: stretch;\n    font-weight: 500;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;\n    padding-top: 0;\n    margin-top: 0;\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;\n    padding-top: 0;\n    margin-top: 0;\n    padding-top: ", ";\n  "])), theme.UNIT(7))
});
var DisclosureStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    height: 48px;\n    align-items: center;\n    flex-direction: row;\n    gap: ", ";\n    padding-right: ", ";\n  "], ["\n    display: flex;\n    height: 48px;\n    align-items: center;\n    flex-direction: row;\n    gap: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(4), theme.UNIT(2))
});
var FootStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DisclosureDividerStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'CollapsiblePanel',
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Head: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  Disclosure: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DisclosureStyles),
  DisclosureDivider: styled(DottedLine)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), DisclosureDividerStyles),
  Body: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Foot: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), FootStyles)
};
export var CollapsiblePanel = function (props) {
  var disclosureProps = useComponentProps(My.NAME, CollapsiblePanelDefaultProps, props);
  var className = disclosureProps.className,
    head = disclosureProps.head,
    foot = disclosureProps.foot,
    body = disclosureProps.body,
    colors = disclosureProps.colors,
    disabled = disclosureProps.disabled,
    divider = disclosureProps.divider,
    disclosure = disclosureProps.disclosure;
  var _a = __read(useState(true), 2),
    isExpanded = _a[0],
    setIsExpanded = _a[1];
  var containerColors = pick(colors, 'background');
  var handleClick = function (event) {
    if (!disabled) {
      event.stopPropagation();
      setIsExpanded(function (isExpanded) {
        return !isExpanded;
      });
    }
  };
  return React.createElement(My.Container, {
    colors: containerColors,
    className: className
  }, React.createElement(My.Head, {
    onClick: handleClick
  }, head, React.createElement(My.Disclosure, null, React.createElement(My.DisclosureDivider, {
    width: 2,
    gap: 5,
    colors: divider.colors
  }), isExpanded ? React.createElement(ChevronUpIconGlyph, {
    size: 16,
    colors: disclosure.colors
  }) : React.createElement(ChevronDownIconGlyph, {
    size: 16,
    colors: disclosure.colors
  }))), React.createElement(AnimateHeight, {
    style: {
      width: '100%',
      boxSizing: 'border-box'
    },
    easing: "cubic-bezier(0.42, 0, 0.58, 1)",
    duration: 400,
    height: isExpanded ? 'auto' : 0
  }, React.createElement(My.Body, null, body), foot && React.createElement(My.Foot, null, foot)));
};
/* @ts-ignore */
CollapsiblePanel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;